"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.images = void 0;
exports.images = function (axios) {
    return {
        postProductImagesUpload: function (postProductImagesUploadRequest) {
            var config = {
                headers: {
                    contentType: 'multipart/form-data'
                }
            };
            return axios.post("/images?mallNo=" + postProductImagesUploadRequest.params.mallNo, postProductImagesUploadRequest.data, config);
        },
        getProductBulkImages: function (getProductBulkImagesRequest) {
            return axios.get('/images/bulk', getProductBulkImagesRequest);
        },
        postProductBulkImages: function (postProductBulkImagesRequest) {
            return axios.post('/images/bulk', postProductBulkImagesRequest.data);
        },
        getProductBulkImagesUploadInfo: function () {
            return axios.get('/images/bulk/upload-info');
        },
        getProductBulkImagesExcel: function (getProductBulkImagexExcelRequest) {
            return axios({
                responseType: 'blob',
                method: 'get',
                url: "/images/bulk/" + getProductBulkImagexExcelRequest.params.no + "/excel"
            });
        }
    };
};
